export enum ResourceType {
    MSH_EMBED_TEMPLATE = 'WdgHub.Generic',
    SHARED_LIB = 'WdgHub.SharedLibrary',
    DATA_CONNECTOR = 'WdgHub.Dataconnector',
    REPORT = 'WdgHub.DataPresentation',
    SMART_TAB = 'WdgHub.SmartTable'
}
